import React, { useState } from 'react'
import type { FC, ReactNode } from 'react'

export type TabMenuProps = {
  tabs: Tab[]
}

export type Tab = {
  title: string
  content: ReactNode
}

export const TabMenu: FC<TabMenuProps> = ({
  tabs,
}) => {
  const [activeTabTitle, setActiveTabTitle] = useState(tabs.length > 0 ? tabs[0].title : "")
  return (
    <div className="basis-full mt-4 px-4 py-4">
      <ul className="flex flex-row">
        {tabs.map((tab, i) => (
          <React.Fragment key={tab.title}>
            <li
              className={`
                p-2 px-4 border-x-2 border-t-2 rounded-tr-lg rounded-tl-lg cursor-pointer
                ${tab.title === activeTabTitle ? '' : 'bg-gray-200 cursor-pointer'}
              `}
              onClick={() => setActiveTabTitle(tab.title)}
            >
              {tab.title}
            </li>
            <li className={`${i === tabs.length - 1 ? "flex-grow" : "p-0.5"} border-b-2`}></li>
          </React.Fragment>
        ))}
      </ul>
      <div className="mt-4 px-2 md:mx-6 py-4">
        {tabs.map(tab => tab.title === activeTabTitle && tab.content)}
      </div>
    </div>
  )
}
